const googleAutoComplete = async ({ searchTerm, country }) => {
    const service = new google.maps.places.AutocompleteService();

    const getSuggestions = (service, data) =>
        new Promise((resolve, reject) => {
            service.getPlacePredictions(data, (response, status) => {
                if (status != google.maps.places.PlacesServiceStatus.OK || !response) {
                    reject(status);
                } else {
                    resolve(response);
                }
            });
        });
    var error = null;
    const results = await getSuggestions(service, {
        input: searchTerm,
        componentRestrictions: { country: country },
        types: ['address'],
    }).catch((e) => {
        error = e;
    });

    return new Promise((resolve, reject) => {
        if (!error) {
            resolve(results);
        } else {
            reject(error);
        }
    });
};

const googlePlaceDetails = async ({ placeId, mapId }) => {
    const service = new google.maps.places.PlacesService(document.getElementById(mapId));

    const getDetails = (service, data) =>
        new Promise((resolve, reject) => {
            service.getDetails(data, (response, status) => {
                if (status != google.maps.places.PlacesServiceStatus.OK || !response) {
                    reject(status);
                } else {
                    if (response?.address_components) {
                        var result = {};
                        response.address_components.forEach((item) => {
                            var type = item.types[0]; //only use the first type
                            if (type == 'country') {
                                result[type] = item.short_name;
                            } else {
                                result[type] = item.long_name;
                            }
                        });
                        resolve(result);
                    }
                }
            });
        });

    var error = null;
    const result = await getDetails(service, {
        placeId: placeId,
        fields: ['address_component'],
    }).catch((e) => {
        error = e;
    });

    return new Promise((resolve, reject) => {
        if (!error) {
            resolve(result);
        } else {
            reject(error);
        }
    });
};

export { googleAutoComplete, googlePlaceDetails };
